<template>
    <div>
        <template class="table-head" >
            <el-table :data="invoiceLists" border height="460" ref="dragTable">
                <el-table-column show-overflow-tooltip :prop="item.prop" :label="item.label" v-for="(item, index) in invoiceItems"
                    :key="index" >
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="scope">
                        <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">修改</el-button> -->
                        <el-button @click="previewClick(scope.row)" type="text" v-has="'07030010'" size="small">预览</el-button>
                        <el-button @click="cellClick(scope.row)" v-if="isDele" type="text" v-has="'07030011'" size="small" :disabled="settlementProcess===1?true:false">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </template>
    </div>
</template>

<script>
import { BILLSTATUS } from '../../../../utils/configuration';
export default {
    props: {
        invoiceLists: {
            type: Array
        },
        invoiceItems: {
            type: Array
        },
        invoiceStatus: {
            type: Number
        },
        settlementProcess: {
            type: Number
        }
    },
    data() {
        return {
            isDele: false
        };
    },
    methods: {
        // handleClick(row) {
        //     this.$emit('handleClick', row);
        // },
        previewClick(row) {
            this.$emit('previewClick', row);
        },
        cellClick(row) {
            this.$emit('cellClick', row);
        }
    },
    mounted() {},
    watch: {
        invoiceStatus(data) {
            if (+data === BILLSTATUS.SEAL_CONFIRMATION ||
            +data === BILLSTATUS.INVOICE_WITHDRAWAL ||
            +data === BILLSTATUS.INVOICE_RETURN) {
                this.isDele = true;
            } else {
                this.isDele = false;
            }
        }
    }
};
</script>

<style lang="less">

</style>